import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/twitter.svg'


const _hoisted_1 = { class: "text-center m-0" }
const _hoisted_2 = { class: "m-0 text-center text-lg" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "40",
  width: "40",
  style: {"width":"40px","height":"40px","max-width":"40px","max-height":"40px"}
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "m-0 font-bold" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "m-0" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "m-0" }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "m-0" }
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_26 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "font-italic"
}
const _hoisted_29 = {
  key: 3,
  class: "font-italic"
}
const _hoisted_30 = {
  key: 0,
  class: "m-0"
}
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = {
  key: 1,
  class: "m-0"
}
const _hoisted_33 = { class: "font-bold font-italic" }
const _hoisted_34 = {
  key: 2,
  class: "m-0 font-italic"
}
const _hoisted_35 = {
  key: 3,
  class: "m-0"
}
const _hoisted_36 = { class: "font-bold" }

import { onMounted, ref, watch } from "vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyThankYouPage',
  props: {
        survey: Object,
        submission: Object,
        socialUrls: Object
    },
  setup(__props) {

const props = __props;

    
    
    const survey = ref<any>(null);
    const submission = ref<any>(null);

    const formattedAnswers = ref<Array<any>>([]);

    const groupBy = (array: Array<any>, key: string) => {
        return array.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    watch(submission, () => {
        if (formattedAnswers.value.length > 0) {
            formattedAnswers.value.splice(0, formattedAnswers.value.length);
        }

        const groupedAnswers = groupBy(submission.value.surveyAnswers, 'questionId');
        
        for (let questionId in groupedAnswers) {
            const allAnswers = groupedAnswers[questionId];
            const answer = allAnswers[0];
            const question = getQuestion(questionId);

            let formattedAnswer: any = {};
            formattedAnswer.questionId = questionId;
            formattedAnswer.isQuizQuestion = question.isQuizQuestion;
            formattedAnswer.questionText = question.question;
            formattedAnswer.questionEmailDontStoreAddress = question.emailDontStoreAddress;
            formattedAnswer.typedAnswer = answer.answer;
            formattedAnswer.isCorrectAnswer = answer.quizIsCorrectAnswer;
            formattedAnswer.answerScore = answer.quizAnswerScore;
            formattedAnswer.correctAnswerExplanation = question.correctAnswerExplanation;
            formattedAnswer.questionType = question.questionType.type;
            formattedAnswer.fileType = question.fileType;
            formattedAnswer.questionGroup = question.questionGroup;

            if (survey.value.isQuiz && question.questionType.parameters instanceof Array) {
                formattedAnswer.correctAnswer = '';
                
                for (let iPar = 0; iPar < question.questionType.parameters.length; iPar++) {
                    const questionParam = question.questionType.parameters[iPar];
                    
                    if (questionParam.isCorrectAnswer) {
                        if (formattedAnswer.correctAnswer != '') {
                            formattedAnswer.correctAnswer += ', ';
                        }

                        formattedAnswer.correctAnswer += questionParam.label;
                    }
                }
            }

            switch (question.questionType.type) {
                case 'date':
                    if (answer.answer) {
                        let dateAnsw = new Date(answer.answer);
                        formattedAnswer.answer = `${dateAnsw.getDate()}/${dateAnsw.getMonth().toString().padStart(2, '0')}/${dateAnsw.getFullYear()}`
                    }
                    break;

                case 'multiCheck':
                    formattedAnswer.answer = '';
                    
                    let filledAnswers = 0;
                    for (let iAnsw = 0; iAnsw < allAnswers.length; ++iAnsw) {
                        const thisAnswerChoice = allAnswers[iAnsw].answer;

                        if ((thisAnswerChoice || '') != '') {
                            if (filledAnswers > 0) {
                                formattedAnswer.answer += ', ';
                            }                           

                            // recupero parametro localizzato
                            const questionLocalizedParam = question.questionType.parameters?.find((qp: any) => qp.value == thisAnswerChoice)?.label;

                            formattedAnswer.answer += questionLocalizedParam || thisAnswerChoice;

                            ++filledAnswers;
                        }
                    }

                    break;
                case 'attachment':
                    formattedAnswer.answer = allAnswers.map((a: any) => a.answer).filter((a: any) => !!a);
                    break;
                case 'bool':
                    if (answer.answer === true || answer.answer === false) {
                        formattedAnswer.answer = answer.answer ? 'Sì' : 'No';
                    }

                    break;

                default:
                    formattedAnswer.answer = answer.answer;
                    break;
            }

            formattedAnswers.value.push(formattedAnswer);
        }

        return formattedAnswers;
    })

    const getQuestion = (questionId: any): any => {
        let questionOut = {};
        survey.value.pages.forEach((page: any) => {
                page.forEach((question: any) => {
                    if (question.questionId == questionId)
                    {
                        questionOut = question;
                    }
                });                    
            });

        return questionOut;
    }

    const getQuestionGroupClass = (answer: any) => {
        var s = "";

        if (answer.questionGroup == '' || answer.questionGroup == null) {
            // non è parte di un gruppo
            return s;
        }

        var previousQuestion = formattedAnswers.value[formattedAnswers.value.findIndex(a => a.questionId == answer.questionId) - 1];
        if (previousQuestion?.questionGroup == answer.questionGroup) {
            // ci sono altre domande dello stesso gruppo prima
            s += "question-group-before ";
        }
        
        var nextQuestion = formattedAnswers.value[formattedAnswers.value.findIndex(a => a.questionId == answer.questionId) + 1];
        if (nextQuestion?.questionGroup == answer.questionGroup) {
            // ci sono altre domande dello stesso gruppo dopo
            s += "question-group-after";
        }

        return s;
    }

    onMounted(() => {
        survey.value = props.survey;
        submission.value = props.submission;
    });

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (survey.value)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "survey-title"
        }, {
          title: _withCtx(() => [
            _createElementVNode("h1", _hoisted_1, _toDisplayString(survey.value.thankYouPage.title), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(survey.value.thankYouPage.text), 1),
            ((__props.socialUrls?.youTubeUrl || '') != '' || 
                    (__props.socialUrls?.instagramUrl || '') != '' ||
                    (__props.socialUrls?.twitterUrl || '') != '' ||
                    (__props.socialUrls?.facebookUrl || '') != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  ((__props.socialUrls?.youTubeUrl || '') != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: __props.socialUrls?.youTubeUrl,
                        target: "_blank",
                        class: "pi pi-youtube no-underline text-black-alpha-70 text-5xl p-3"
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  ((__props.socialUrls?.instagramUrl || '') != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: __props.socialUrls?.instagramUrl,
                        target: "_blank",
                        class: "pi pi-instagram no-underline text-black-alpha-70 text-5xl p-3"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  ((__props.socialUrls?.twitterUrl || '') != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: __props.socialUrls?.twitterUrl,
                        target: "_blank",
                        class: "pi no-underline text-black-alpha-70 text-5xl p-3"
                      }, _hoisted_8, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  ((__props.socialUrls?.facebookUrl || '') != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: __props.socialUrls?.facebookUrl,
                        title: "Facebook",
                        target: "_blank",
                        class: "pi pi-facebook no-underline text-black-alpha-70 text-5xl p-3"
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (survey.value && submission.value && survey.value.isQuiz && (submission.value.quizPassed === true || submission.value.quizPassed === false))
      ? (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
          title: _withCtx(() => [
            _createVNode(_component_Message, {
              severity: submission.value.quizPassed ? 'success' : 'error',
              closable: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_10, [
                  (submission.value.quizPassed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Quiz superato!"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "Quiz non superato"))
                ])
              ]),
              _: 1
            }, 8, ["severity"])
          ]),
          content: _withCtx(() => [
            _createElementVNode("p", _hoisted_13, [
              _createTextVNode("Punteggio totale: "),
              _createElementVNode("span", _hoisted_14, _toDisplayString(submission.value.quizTotalScore), 1)
            ]),
            _createElementVNode("p", _hoisted_15, [
              _createTextVNode("Punteggio minimo per il superamento del quiz: "),
              _createElementVNode("span", _hoisted_16, _toDisplayString(survey.value.quizScoreParameters.quizPassScore), 1)
            ]),
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode("Risposte esatte: "),
              _createElementVNode("span", _hoisted_18, _toDisplayString(submission.value.quizCorrectAnswers), 1)
            ]),
            _createElementVNode("p", _hoisted_19, [
              _createTextVNode("Risposte sbagliate: "),
              _createElementVNode("span", _hoisted_20, _toDisplayString(submission.value.quizWrongAnswers), 1)
            ]),
            _createElementVNode("p", _hoisted_21, [
              _createTextVNode("Risposte non date: "),
              _createElementVNode("span", _hoisted_22, _toDisplayString(submission.value.quizUnanswered), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (submission.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(formattedAnswers.value, (answer) => {
          return (_openBlock(), _createBlock(_component_Card, {
            key: "'question_' + question.id",
            class: _normalizeClass(["p-fluid", getQuestionGroupClass(answer)])
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(answer.questionId) + ". " + _toDisplayString(answer.questionText), 1)
            ]),
            content: _withCtx(() => [
              (answer.questionType == 'attachment' && answer.answer && answer.answer.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (answer.fileType == 'image')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer.answer, (attachment) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              (attachment?.startsWith('data:image/'))
                                ? (_openBlock(), _createBlock(_component_Image, {
                                    key: 0,
                                    src: attachment,
                                    alt: 'Allegato risposta ' + answer.questionId,
                                    width: "250",
                                    preview: ""
                                  }, null, 8, ["src", "alt"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_25, "Immagine"))
                            ]))
                          }), 256))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(answer.answer.length == 1 ? '1 file allegato' : answer.answer.length + ' file allegati'), 1))
                  ]))
                : ((answer.answer || '') != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(answer.answer), 1))
                  : (answer.questionEmailDontStoreAddress)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Non memorizziamo il tuo indirizzo e-mail"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29, "Non risposta")),
              ((answer.isQuizQuestion && answer.correctAnswer))
                ? (_openBlock(), _createBlock(_component_Message, {
                    key: 4,
                    severity: answer.isCorrectAnswer ? 'success' : 'error',
                    closable: false
                  }, {
                    default: _withCtx(() => [
                      (answer.answer)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(answer.isCorrectAnswer ? 'Risposta esatta!' : 'Risposta sbagliata.'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!answer.isCorrectAnswer)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                            _createTextVNode("Risposta esatta: "),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(answer.correctAnswer) + ".", 1)
                          ]))
                        : _createCommentVNode("", true),
                      ((answer.correctAnswerExplanation || '' != ''))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(answer.correctAnswerExplanation), 1))
                        : _createCommentVNode("", true),
                      (answer.answerScore != null && answer.answerScore != undefined)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                            _createTextVNode("Punteggio: "),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(answer.answerScore), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["severity"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}
}

})